import { alpha, Box, useMediaQuery } from "@mui/material";
import { AuthBg } from "assets/index";
import { Outlet } from "react-router-dom";
import theme from "themes/Theme";

const AuthLayout = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <Box sx={styles.container}>
      <Box sx={styles.authFormContainer}>
        <Outlet />
      </Box>
      {isMobile ? null : (
        <Box sx={styles.bgImage}>
          <Box sx={styles.bgOverlay} />
        </Box>
      )}
    </Box>
  );
};
export default AuthLayout;
const styles = {
  container: {
    display: "flex",
    minHeight: "100vh",
    width: "100vw",
    flexDirection: { xs: "column", md: "row" },
    overflowY: "scroll",
  },
  authFormContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  bgImage: {
    background: `url(${AuthBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    minHeight: "100vh",
    height: "100%",
    flex: 1.5,
    position: "relative",
  },
  bgOverlay: {
    position: "absolute",
    top: 0,
    right: 0,
    height: "100%",
    width: "100%",
  },
};
